// extracted by mini-css-extract-plugin
export var button = "_de-4";
export var hasDarkBackground = "_de-7";
export var hasLightBackground = "_de-6";
export var iconWrapper = "_de-0";
export var large = "_de-2";
export var medium = "_de-1";
export var small = "_de-5";
export var xsmall = "_de-3";